import { Moment } from "moment";
import { DocumentStatus } from "../enum/documentStatus";
import { Order } from "../order/order";



export class Incident {
    id: string;
    reportDate: Moment;
    cause: string;
    orderId: number;
    status: boolean;
    minDeliveryDate: Moment;
    maxDeliveryDate: Moment;
    minLoadingDate: Moment;
    maxLoadingDate: Moment;
    loadingPlace: string;
    deliveryPlace: string;
    documentStatus: DocumentStatus;
    respondBefore: Moment;
    preventiveAction: string;
    correctiveAction: string;
    rootcause: string;
    summaryOfComplaint: string;
    incidentId: number;
    order: Order;
}